const assetsAccessor = {
  displayName: "displayName", //asset name
  assetId: "assetId", //asset id - name
  product: "product",
  productDescription: "productDescription",
  manufacturer: "manufacturer",
  itemQuantity: "itemQuantity",
  serialNumber: "serialNumber",
  assetType: "assetType",
  shiCategory: "shiCategory",
  subCategory: "subCategory",
  microCategory: "microCategory",
  shiUseState: "shiUseState",
  discoveredOnNet: "discoveredOnNet",
  networkId: "networkId",
  networkAddress: "networkAddress",
  shiLifecycleState: "shiLifecycleState",
  contract: "contract",
  contractId: "contractId",
  contractType: "contractType",
  serviceLevelAgreement: "serviceLevelAgreement",
  coveredStatus: "coveredStatus",
  coveredStartDate: "coveredStartDate",
  coveredEndDate: "coveredEndDate",
  renewalDate: "renewalDate",
  endOfLife: "endOfLife",
  endOfSaleDate: "endOfSaleDate",
  endOfSoftwareMaintenanceDate: "endOfSoftwareMaintenanceDate",
  lastDateOfSupport: "lastDateOfSupport",
  shipDate: "shipDate",
  managingPartner: "managingPartner",
  manufacturerGlobalCustomerName: "manufacturerGlobalCustomerName",
  displayLocationName: "displayLocationName",
  locationAddress: "locationAddress",
  siteLocation: "siteLocation",
  children: "children",
  tags: "tags",
  roadmaps: "roadmaps",
  datasource: "datasource",
};

export default assetsAccessor;
